<div class="container-fluid">
  <h1
    style="
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; text-align: center;
    "
  >
    To-Do By Users
  </h1>

  <div class="container-fluid">
    <table class="table table-dark table-striped">
      <thead>
        <tr style="background-color: black; color: white; font-style: bold">
          <th class="td">Name</th>
          <th class="td">Things To Do</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td class="td">{{ user.name }}</td>
          <td class="td">
            <a [routerLink]="['detail', user.id]" routerLinkActive="active"
              >See list</a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="d-flex justify-content-center">
  <div class="spinner-grow text-dark" role="status" *ngIf="loading">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div style="text-align: right; margin-right: 5%; margin-top: 2.5%">
  <a routerLink="/todos">See all To Do List</a>
</div>

<div class="container mt-5">
  <router-outlet></router-outlet>
</div>

<p style="font-style: italic">Data from JSONPlaceholder</p>
